module.exports = __webpack_public_path__ + "assets/img/reset-password-v2-dark.ac00cd75.svg";